import React, { useState, useEffect } from "react";
import classes from './PaymentVoucher.module.css';
import HeaderNav from '../../../Components/Dahboard Header/HeaderNav/HeaderNav';
import Footer from "../../../Components/Footer/Footer";
import { useLocation, useNavigate } from "react-router-dom";
import api, { BASE_URL } from "../../../Components/API/Api";
import makepayment from "../../../Assets/credit-card-validation.png"
import { useUser } from '../../../UserContext';
import {
    BarChart2,
    Filter,
    CalendarClock,
    Mail,
    ArrowLeft,
    Printer,
    Eye,
    Trash,
    // Download,
    Settings
} from 'lucide-react';
import swal from 'sweetalert'; // Import SweetAlert

const MonthlySalaryCompetition = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const token = localStorage.getItem("authToken");
    const [ledgerData, setLedgerData] = useState([]);
    const [loading, setLoading] = useState(true);
    const { user, isAuthenticated, logout } = useUser();
    // store salary competition data fetched from /v1/employee/salary_competition
    const [salaryCompetitionData, setSalaryCompetitionData] = useState([]);
    const [selectMetrics, setSelectedMetrics] = useState(null);
    const [selectedRows, setSelectedRows] = useState([]);
    // NEW: state for selected month
    const [selectedMonth, setSelectedMonth] = useState("");
    const [showModal, setShowModal] = useState(false); // Modal state
    const [showPaymentInstructionModal, setShowPaymentInstructionModal] = useState(false); // Payment instruction modal
    const [makingPayment, setMakingPayment] = useState(false);
    const [processingCompute, setProcessingCompute] = useState(false);


    // Debug: Log user data to see what's available
    console.log('DashboardHeader - User data:', user);
    console.log('DashboardHeader - Is authenticated:', isAuthenticated);

    // Get user's display name - fallback to 'User' if no name is available
    const displayName = user?.name || user?.firstName || user?.email?.split('@')[0] || 'User';

    console.log('DashboardHeader - Display name:', displayName);
    // new: store logged-in company info
    const [companyInfo, setCompanyInfo] = useState({
        name: "",
        address: "",
        email: "",
        phone: "",
        logo: ""
    });

    // NEW: base currency code & symbol (set from company settings)
    const [baseCurrencyCode, setBaseCurrencyCode] = useState(null);
    const [baseCurrencySymbol, setBaseCurrencySymbol] = useState(null);

    // NEW: read payment passed via navigate state — declare before any useEffect that references it
    const payment = location.state?.payment || null;

    const typeMap = {
        "1": "Assets",
        "2": "Liabilities",
        "3": "Equity",
        "4": "Revenue",
        "5": "Expenses"
    };

    const categoryMap = {
        "1": "Current Assets",
        "2": "Non-current Assets",
        "3": "Current Liabilities",
        "4": "Non-current Liabilities",
        "5": "Equity",
        "6": "Operating Revenue",
        "7": "Cost of Sales",
        "8": "Operating Expenses"
    };


    const formatMoney = (value) => {
        const num = Number(value || 0);
        return num.toLocaleString("en-NG", { minimumFractionDigits: 2 });
    };

    useEffect(() => {
        const fetchAccounts = async () => {
            try {
                const response = await api.get(`/v1/chart_of_account`);

                const accounts = Array.isArray(response.data.data?.data) ? response.data.data.data : [];
                const mappedData = accounts.map((account, index) => ({
                    id: account.id || `account-${index}`,
                    ref: account.gl_code || `REF-${index}`,
                    description: account.gl_name,
                    type: typeMap[account.class_id] || "Unknown",
                    category: categoryMap[account.category_id] || "Unknown",
                    balance: formatMoney(account.balance || 0),
                    status: account.status === "1" ? "Active" : "Inactive",
                }));


                setLedgerData(mappedData);
            } catch (error) {
                console.error("Error fetching chart of accounts:", error);
            } finally {
                setLoading(false);
            }
        };
        if (token) fetchAccounts();
        else setLoading(false);
    }, [token]);

    // new: fetch company info for header display
    useEffect(() => {
        const fetchCompanyInfo = async () => {
            if (!token) return;
            try {
                const res = await api.get(`/v1/companies/get-info`);
                const item = Array.isArray(res?.data?.data) ? res.data.data[0] : (res?.data?.data || null);
                if (item) {
                    setCompanyInfo({
                        name: item.name || "",
                        address: item.address || "",
                        email: item.email || "",
                        phone: item.phone_number || "",
                        logo: item.logo || ""
                    });

                    // NEW: resolve base currency from company info if present
                    const currencyId = item?.currency_base;
                    if (currencyId) {
                        try {
                            const currenciesRes = await api.get(`/v1/fetch-all-currencies`);
                            const currencies = Array.isArray(currenciesRes?.data?.data) ? currenciesRes.data.data : (currenciesRes?.data?.data || []);
                            const baseCurrency = currencies.find(c => String(c.id) === String(currencyId));
                            if (baseCurrency) {
                                setBaseCurrencyCode(baseCurrency.code || null);
                                setBaseCurrencySymbol(baseCurrency.symbol || null);
                            }
                        } catch (curErr) {
                            console.error("Failed to fetch currencies for base currency", curErr);
                        }
                    }
                }
            } catch (err) {
                console.error("Failed to fetch company info", err);
            }
        };
        fetchCompanyInfo();
    }, [token]);

    // NEW: helper to title-case a name
    const titleCase = (s) => {
        if (!s || typeof s !== "string") return s;
        return s
            .split(" ")
            .map(p => p.trim())
            .filter(Boolean)
            .map(word => word[0]?.toUpperCase() + word.slice(1).toLowerCase())
            .join(" ");
    };

    // NEW: helper to synchronously get stored user display name (localStorage / sessionStorage)
    const getStoredUserName = () => {
        // First try the exact key HeaderNav appears to use
        try {
            const rawUser = localStorage.getItem("user");
            if (rawUser) {
                try {
                    const parsedUser = JSON.parse(rawUser);
                    const candidate =
                        parsedUser?.name ||
                        parsedUser?.data?.name ||
                        parsedUser?.user?.name ||
                        parsedUser?.full_name ||
                        parsedUser?.username;
                    if (candidate) return titleCase(String(candidate));
                    // raw string fallback
                } catch {
                    if (rawUser.trim()) return titleCase(rawUser.trim());
                }
            }
        } catch {
            // ignore and continue to other keys
        }

        const checkStorage = (storage) => {
            const possibleKeys = ["userContext", "userInfo", "authUser", "authUserInfo", "currentUser", "profile", "userProfile"];
            for (const key of possibleKeys) {
                const raw = storage.getItem(key);
                if (!raw) continue;
                try {
                    const parsed = JSON.parse(raw);
                    const candidate =
                        parsed?.name ||
                        parsed?.full_name ||
                        parsed?.username ||
                        (parsed?.data && (parsed.data.name || parsed.data.full_name)) ||
                        (parsed?.user && (parsed.user.name || parsed.user.full_name)) ||
                        (parsed?.first_name && parsed?.last_name && `${parsed.first_name} ${parsed.last_name}`);
                    if (candidate) return titleCase(String(candidate));
                } catch {
                    if (raw && raw.trim()) return titleCase(raw.trim());
                }
            }
            return null;
        };

        return checkStorage(localStorage) || checkStorage(sessionStorage) || null;
    };

    // NEW: prefer logged-in user's display name for "Prepared By" (initialize from storage)
    const [preparedByName, setPreparedByName] = useState(() => getStoredUserName() || "");

    // Keep preparedByName in sync when other code updates localStorage (e.g., HeaderNav)
    useEffect(() => {
        const handleStorage = (event) => {
            if (!event) return;
            const watchedKeys = ["user", "userContext", "userInfo", "authUser", "authUserInfo", "currentUser", "profile", "userProfile"];
            if (watchedKeys.includes(event.key)) {
                setPreparedByName(getStoredUserName() || "");
            }
        };
        window.addEventListener("storage", handleStorage);
        // also refresh on mount in case HeaderNav updated after this component mounted
        setPreparedByName(getStoredUserName() || preparedByName || "");
        return () => window.removeEventListener("storage", handleStorage);
    }, []);

    // POLL: same-tab updates to localStorage (HeaderNav may set user after this component mounted)
    useEffect(() => {
        if (preparedByName) return;
        let attempts = 0;
        const maxAttempts = 10; // 10 * 500ms = 5s max
        const intervalId = setInterval(() => {
            const name = getStoredUserName();
            if (name) {
                setPreparedByName(name);
                clearInterval(intervalId);
                return;
            }
            attempts += 1;
            if (attempts >= maxAttempts) {
                clearInterval(intervalId);
            }
        }, 500);

        return () => clearInterval(intervalId);
    }, [preparedByName]);

    const pageMap = {
        '/dashboard': 'Dashboard',
        '/transactions': 'Transactions',
        '/accounts': 'Accounting',
        '/reports': 'Reports',
        '/banking': 'Banking',
        '/settings': 'Settings',
    };

    const handleMail = () => swal("Info", "Mail clicked!", "info");
    const handlePrinter = () => window.print();
    const handleDownload = () => {
        const csvContent = [
            ["Ref", "Description", "Type", "Category", "Balance", "Status"],
            ...ledgerData.map(d => [d.ref, d.description, d.type, d.category, d.balance, d.status])
        ].map(e => e.join(",")).join("\n");

        const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.setAttribute("href", url);
        link.setAttribute("download", "chart_of_accounts.csv");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };
    const handleSettings = () => navigate("/settings/chart-ledger");

    // helper to format date safely
    const formatDate = (dateStr) => {
        if (!dateStr) return "N/A";
        const d = new Date(dateStr);
        if (isNaN(d)) return dateStr;
        return d.toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' });
    };

    // helper to format money using existing formatMoney
    const formatCurrency = (value) => {
        return formatMoney(value);
    };

    // derive receipt-related values from payment with fallbacks
    const receiptNo = payment?.receipt_number || payment?.invoice_number || payment?.uuid || "N/A";
    const receiptDate = payment?.transaction_date || payment?.date_of_invoice || payment?.created_at || null;
    const receivedFrom = payment?.particular || payment?.supplier?.name || payment?.supplier || "N/A";
    const paymentMethod = payment?.mode?.name || (payment?.payment_mode
        ? (String(payment.payment_mode) === "1" ? "Bank Transfer" : String(payment.payment_mode) === "2" ? "Cheque" : `Method ${payment.payment_mode}`)
        : "N/A");
    const referenceNo = payment?.invoice_number || payment?.uuid || "N/A";

    // Use base currency (from company) first, then payment currency, then defaults
    const displayCurrencyCode = baseCurrencyCode || payment?.currency?.code || "NGN";
    const displayCurrencySymbol = baseCurrencySymbol || payment?.currency?.symbol || "₦";

    const lineAmountValue = parseFloat(payment?.total_currency_amount ?? payment?.currency_amount ?? payment?.amount ?? 0);
    const subtotalValue = lineAmountValue;
    const taxValue = 0; // API doesn't provide tax per receipt in sample; keep 0 unless you want to compute
    const totalValue = parseFloat(payment?.total_converted_amount ?? payment?.total_currency_amount ?? subtotalValue);

    // NEW: convert numbers to words (handles integer + two-decimal fractional part)
    const integerToWords = (n) => {
        if (n === 0) return "zero";
        const units = ["", "one", "two", "three", "four", "five", "six", "seven", "eight", "nine",
            "ten", "eleven", "twelve", "thirteen", "fourteen", "fifteen", "sixteen",
            "seventeen", "eighteen", "nineteen"];
        const tens = ["", "", "twenty", "thirty", "forty", "fifty", "sixty", "seventy", "eighty", "ninety"];
        const scales = [
            { value: 1e12, name: "trillion" },
            { value: 1e9, name: "billion" },
            { value: 1e6, name: "million" },
            { value: 1e3, name: "thousand" },
            { value: 1e2, name: "hundred" }
        ];

        const words = [];

        const helper = (num) => {
            let str = "";
            if (num < 20) return units[num];
            if (num < 100) {
                const t = Math.floor(num / 10);
                const u = num % 10;
                return tens[t] + (u ? "-" + units[u] : "");
            }
            for (let i = 0; i < scales.length; i++) {
                const { value, name } = scales[i];
                if (num >= value) {
                    const count = Math.floor(num / value);
                    const remainder = num % value;
                    if (value === 100) {
                        str += helper(count) + " " + name;
                    } else {
                        str += helper(count) + " " + name;
                    }
                    if (remainder) str += " " + helper(remainder);
                    return str;
                }
            }
            return str;
        };

        return helper(n).trim();
    };

    const convertAmountToWords = (amount, currencyCode) => {
        const absAmount = Math.abs(Number(amount) || 0);
        const integerPart = Math.floor(absAmount);
        const fractionPart = Math.round((absAmount - integerPart) * 100); // two decimals

        // currency names and fractional unit names map (add more as needed)
        const currencyNameMap = {
            NGN: { name: "Naira", fraction: "kobo" },
            USD: { name: "Dollar", fraction: "cents" },
            EUR: { name: "Euro", fraction: "cents" },
            GBP: { name: "Pound", fraction: "pence" }
        };
        const currencyInfo = currencyNameMap[currencyCode] || { name: currencyCode || "Units", fraction: "cents" };

        const intWords = integerToWords(integerPart);
        let words = "";

        if (integerPart === 0 && fractionPart === 0) {
            words = `Zero ${currencyInfo.name}`;
        } else if (fractionPart === 0) {
            words = `${intWords} ${currencyInfo.name}`;
        } else if (integerPart === 0) {
            const fracWords = integerToWords(fractionPart);
            words = `${fracWords} ${currencyInfo.fraction} ${currencyInfo.name.startsWith(currencyCode) ? "" : ""}`.trim();
            // prefer "X kobo" when no integer part
        } else {
            const fracWords = integerToWords(fractionPart);
            words = `${intWords} ${currencyInfo.name} and ${fracWords} ${currencyInfo.fraction}`;
        }

        // Capitalize first letter and append "Only"
        return words.replace(/^\w/, c => c.toUpperCase()) + " Only";
    };

    const amountInWords = convertAmountToWords(totalValue, displayCurrencyCode);

    // fetch salary competition data from /v1/employee/salary_competition
    const fetchSalaryCompetition = async (monthParam) => {
        try {
            if (!monthParam) {
                swal("Error", "Please select a month to proceed.", "error");
                return;
            }

            setLoading(true);
            const companyId = localStorage.getItem("company_id");
            // Use centralized api so interceptor adds auth/company/store
            const res = await api.post('/v1/monthly_salary_computation/compute', { month: monthParam, company_id: companyId });

            if (res?.data?.status === false) {
                swal("Error", res?.data?.message || "An error occurred while fetching data.", "error");
                setSalaryCompetitionData([]);
                return false;
            } else {
                const result = res?.data?.data?.data || []; // Extract the nested data array
                console.log("Fetched salary competition data:", result);
                setSalaryCompetitionData(result);
                return true;
            }
        } catch (error) {
            console.error("Error fetching salary competition data:", error);
            swal(error.response.data.message);
            setSalaryCompetitionData([]);
            return false;
        } finally {
            setLoading(false);
        }
    };

    // Wrapper for Process button: show processing state, call compute, close modal on success
    const handleComputeProcess = async () => {
        if (!selectedMonth) {
            swal("Error", "Please select a month to proceed.", "error");
            return;
        }

        try {
            setProcessingCompute(true);
            const success = await fetchSalaryCompetition(selectedMonth);
            if (success) {
                // close compute modal on successful compute
                setShowModal(false);
                swal("Success", "Payroll computed successfully.", "success");
            }
        } finally {
            setProcessingCompute(false);
        }
    };

    // UPDATED: navigate to the payment receipt route and pass payment and computation date via router state
    const handleOpenReceipt = (employee) => {
        if (!employee) {
            swal("Error", "Employee data is missing or invalid.", "error");
            return;
        }
        // Pass both employee and computation month/year
        navigate('/payroll/monthly-salary-competition-slip', {
            state: {
                payment: {
                    ...employee,
                    computation_date: (salaryCompetitionData?.date || selectedMonth || ""),
                }
            }
        });
    };

    // NEW: handler for Process button
    const handleProcessClick = async () => {
        try {
            if (!selectedMonth) {
                swal("Error", "Please select a month first and click Preview.", "error");
                return;
            }

            setLoading(true);
            const authToken = localStorage.getItem("authToken");

            const res = await api.get('/v1/monthly_salary_computation/fetch', { params: { month: selectedMonth } });

            if (res?.data?.status === false) {
                swal("Error", res?.data?.message || "Failed to fetch salary data.", "error");
                setSalaryCompetitionData([]);
            } else {
                const result = res?.data?.data?.data || []; // Extract the nested data array
                console.log("Filtered salary data:", result);
                setSalaryCompetitionData(result);
            }
        } catch (error) {
            console.error("Error fetching filtered salary data:", error);
            swal("Error", "Failed to fetch salary data. Please try again.", "error");
            setSalaryCompetitionData([]);
        } finally {
            setLoading(false);
        }
    };

    const handlePreviewClick = async () => {
        try {
            if (!selectedMonth) {
                swal("Error", "Please select a month first.", "error");
                return;
            }

            setLoading(true);
            const authToken = localStorage.getItem("authToken");

            const res = await api.get('/v1/monthly_salary_computation/fetch', { params: { month: selectedMonth } });

            if (res?.data?.status === false) {
                swal("Error", res?.data?.message || "Failed to fetch salary data.", "error");
                setSalaryCompetitionData([]); // Clear table data on error
            } else {
                const result = res?.data?.data?.data || []; // Extract the nested data array
                console.log("Filtered salary data:", result);
                setSalaryCompetitionData(result); // Update table data only when "Preview" is clicked
            }
        } catch (error) {
            console.error("Error fetching filtered salary data:", error);
            swal("Error", "Failed to fetch salary data. Please try again.", "error");
            setSalaryCompetitionData([]); // Clear table data on error
        } finally {
            setLoading(false);
        }
    };

    // Open Payment Instruction modal (use selected rows if any, otherwise all)
    const handleOpenPaymentInstruction = () => {
        if (!Array.isArray(salaryCompetitionData) || salaryCompetitionData.length === 0) {
            swal("Error", "No salary data available to generate payment instructions.", "error");
            return;
        }

        setShowPaymentInstructionModal(true);
    };

    // Make Payment: send transfer batch to backend which will talk to Paystack
    const handleMakePayment = async () => {
        if (!Array.isArray(paymentInstructionRows) || paymentInstructionRows.length === 0) {
            swal("Error", "No recipient rows selected for payment.", "error");
            return;
        }

        if (!token) {
            swal("Error", "You must be logged in to make payments.", "error");
            return;
        }

        // Confirm with user
        const confirm = await swal({
            title: "Confirm",
            text: `Proceed to make payments to ${paymentInstructionRows.length} recipients?`,
            icon: "warning",
            buttons: ["Cancel", "Proceed"]
        });

        if (!confirm) return;

        try {
            setMakingPayment(true);

            // Build transfers payload - backend should validate and map to Paystack recipients/transfers
            const transfers = paymentInstructionRows.map((it) => {
                const salaryStruct = it.salary_structure || {};
                const accountNumber = it.bank_account?.account_number || it.account_number || it.account_no || it.bank_account_no || it.bank_account_number || "";
                const bankCode = it.bank?.code || it.bank_code || it.bank?.id || null; // backend can resolve bank name if needed
                const beneficiaryName = it.name || it.employee_name || it.beneficiary_name || it.employee_id || "";
                const amountValue = Math.round((parseFloat(salaryStruct.net_salary ?? it.net_salary ?? it.net_pay ?? 0) || 0) * 100); // send in kobo/cents

                return {
                    account_number: accountNumber,
                    bank_code: bankCode,
                    beneficiary_name: beneficiaryName,
                    amount: amountValue,
                    currency: baseCurrencyCode || "NGN",
                    reference: `SALPAY_${it.employee_id || Math.random().toString(36).slice(2,9)}`
                };
            });

            // call backend endpoint that will create recipients and initiate Paystack transfers using server secret
            const payload = {
                batch_reference: `SALARY_BATCH_${selectedMonth || new Date().toISOString().slice(0,10)}`,
                transfers
            };

            const res = await api.post('/v1/payments/paystack/transfer-batch', payload);

            if (res?.data?.status === true || res?.data?.success === true) {
                swal("Success", res?.data?.message || "Transfer initiated successfully. Check backend for status.", "success");
                // Optionally close modal
                setShowPaymentInstructionModal(false);
            } else {
                console.error("Paystack transfer response:", res?.data);
                swal("Error", res?.data?.message || "Failed to initiate transfer. See console for details.", "error");
            }
        } catch (err) {
            console.error("Error initiating transfers:", err);
            swal("Error", "Failed to initiate transfers. See console for details.", "error");
        } finally {
            setMakingPayment(false);
        }
    };

    const allSelected = selectedRows.length === salaryCompetitionData.length;

    const handleSelectAll = () => {
        if (allSelected) {
            setSelectedRows([]);
        } else {
            setSelectedRows(salaryCompetitionData.map((_, i) => i));
        }
    };

    const handleSelectRow = (index) => {
        if (selectedRows.includes(index)) {
            setSelectedRows(selectedRows.filter((i) => i !== index));
        } else {
            setSelectedRows([...selectedRows, index]);
        }
    };


    // single-line ellipsis style for table cells
    const ellipsisStyle = {
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        maxWidth: 180,
        textAlign: "center",
        display: "block",
        cursor: "pointer"
    };


    // Collect all unique allowance and deduction types from the data
    const allowanceSet = new Set();
    const deductionSet = new Set();
    salaryCompetitionData.forEach(emp => {
        emp.salary_structure?.allowances?.forEach(a => allowanceSet.add(a.type_name));
        emp.salary_structure?.deductions?.forEach(d => deductionSet.add(d.type_name));
        // Ensure Tax appears under deductions columns (like basic salary appears under earnings)
        if (emp?.salary_structure?.tax !== undefined && emp?.salary_structure?.tax !== null) {
            deductionSet.add("Tax");
        }
    });

    const allowanceHeaders = [...allowanceSet];
    const deductionHeaders = [...deductionSet];

    // Rows to include in payment instruction: selected rows if any, otherwise all
    const paymentInstructionRows = (selectedRows && selectedRows.length > 0)
        ? selectedRows.map(i => salaryCompetitionData[i]).filter(Boolean)
        : salaryCompetitionData;

    // Compute total amount for payment instruction rows (for print-only total)
    const paymentInstructionTotal = (Array.isArray(paymentInstructionRows) && paymentInstructionRows.length > 0)
        ? paymentInstructionRows.reduce((sum, it) => {
            const salaryStruct = it.salary_structure || {};
            const amt = parseFloat(salaryStruct.net_salary ?? it.net_salary ?? it.net_pay ?? 0) || 0;
            return sum + amt;
        }, 0)
        : 0;

    useEffect(() => {
        const fetchSalaryData = async () => {
            try {
                setLoading(true);
                const authToken = localStorage.getItem("authToken");

                const res = await api.get('/v1/monthly_salary_computation/fetch');

                if (res?.data?.status === false) {
                    swal("Error", res?.data?.message || "Failed to fetch salary data.", "error");
                    setSalaryCompetitionData([]);
                } else {
                    const result = res?.data?.data?.data || []; // Extract the nested data array
                    console.log("Fetched salary data:", result);
                    setSalaryCompetitionData(result);
                }
            } catch (error) {
                console.error("Error fetching salary data:", error);
                swal("Error", "Failed to fetch salary data. Please try again.", "error");
                setSalaryCompetitionData([]);
            } finally {
                setLoading(false);
            }
        };

        fetchSalaryData();
    }, []); // Fetch data on component mount

    return (
        <div>
            {/* Modal for Compute Payroll */}
            {showModal && (
                <div className={classes.modalOverlay}>
                    <div className={classes.modalContent}>
                        <form className={classes.form}>

                            <div className={classes.group}>
                                <label>Month:</label>
                                <div className={classes.dropdownWrapper}>
                                    <input
                                        type="month"
                                        className={classes.statusDropdown}
                                        value={selectedMonth}
                                        onChange={(e) => setSelectedMonth(e.target.value)} // Only update state, no filtering yet
                                    />
                                </div>
                            </div>
                            <div className={classes.group1}>
                                <button
                                    className={classes.greenBtn}
                                    type="button"
                                    onClick={handleComputeProcess}
                                    disabled={processingCompute}
                                    style={processingCompute ? { background: '#d1d5db', color: '#6b7280', cursor: 'not-allowed' } : {}}
                                    aria-busy={processingCompute}
                                >
                                    <BarChart2 size={16} style={{ marginRight: "6px" }} />
                                    {processingCompute ? 'Processing...' : 'Process'}
                                </button>

                            </div>




                        </form>
                        <div style={{display: "flex", justifyContent: "space-between", }}>
                            <div/>
                            <button
                                type="button"
                                className={classes.cancelBtn}
                                style={{ border: "1px solid red", background: "white", color: "red", padding: "8px 16px", borderRadius: "4px", cursor: "pointer" }}
                                onClick={() => setShowModal(false)}
                            >
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Modal: Payment Instruction / Transfer Schedule */}
            {showPaymentInstructionModal && (
                <div className={classes.modalOverlay}>
                    <div className={classes.modalContent} style={{ width: '90%', maxWidth: 1100 }}>
                        <div className={classes.printHeaderRow} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
                            <div className={classes.companyInfo}>
                                <strong>{companyInfo.name || 'UNITED BANK FOR AFRICA PLC'}</strong>
                                <div style={{ fontSize: 12 }}>TRANSFER SCHEDULE</div>
                            </div>
                            <div className={classes.batchInfo} style={{ textAlign: 'right' }}>
                                <div>Batch Number: {new Date().toISOString().slice(0,10).replace(/-/g,'')}</div>
                                <div className={classes.printAmount} style={{ fontSize: 12 }}>Amount ({baseCurrencyCode || 'NGN'})</div>
                            </div>
                        </div>

                        <div style={{ overflowX: 'auto', maxHeight: '60vh' }}>
                            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12 }}>
                                <thead>
                                    <tr>
                                        <th style={{ border: '1px solid #ccc', padding: 6 }}>S/N</th>
                                        <th style={{ border: '1px solid #ccc', padding: 6 }}>Date</th>
                                        <th style={{ border: '1px solid #ccc', padding: 6 }}>Bank Name</th>
                                        <th style={{ border: '1px solid #ccc', padding: 6 }}>Acct. No.</th>
                                        <th style={{ border: '1px solid #ccc', padding: 6 }}>Name of Beneficiary</th>
                                        <th style={{ border: '1px solid #ccc', padding: 6, textAlign: 'right' }}>Amount ({baseCurrencyCode || 'NGN'})</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {(Array.isArray(paymentInstructionRows) && paymentInstructionRows.length > 0) ? (
                                        paymentInstructionRows.map((it, idx) => {
                                            const salaryStruct = it.salary_structure || {};
                                            const bankName = it.bank?.name || it.bank_name || it.bankName || '—';
                                            const acctNo = it.bank_account?.account_number || it.bank_account_no || it.account_number || it.account_no || it.bank_account_number || '—';
                                            const beneficiary = it.name || it.employee_name || it.beneficiary_name || it.employee_id || '—';
                                            const amountVal = parseFloat(salaryStruct.net_salary ?? it.net_salary ?? it.net_pay ?? 0) || 0;
                                            return (
                                                <tr key={idx}>
                                                        <td style={{ border: '1px solid #eee', padding: '4px 6px', lineHeight: 1.1, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{idx + 1}</td>
                                                            <td style={{ border: '1px solid #eee', padding: '4px 6px', lineHeight: 1.1, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} title={selectedMonth || new Date().toLocaleDateString('en-GB')}>{selectedMonth || new Date().toLocaleDateString('en-GB')}</td>
                                                            <td style={{ border: '1px solid #eee', padding: '4px 6px', lineHeight: 1.1, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{bankName}</td>
                                                            <td style={{ border: '1px solid #eee', padding: '4px 6px', lineHeight: 1.1, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{acctNo}</td>
                                                            <td style={{ border: '1px solid #eee', padding: '4px 6px', lineHeight: 1.1, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{beneficiary}</td>
                                                            <td style={{ border: '1px solid #eee', padding: '4px 6px', lineHeight: 1.1, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', textAlign: 'right' }}>{formatMoney(amountVal)}</td>
                                                </tr>
                                            );
                                        })
                                    ) : (
                                        <tr>
                                            <td colSpan={6} style={{ textAlign: 'center', padding: 12 }}>No rows to show.</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                            {/* Print-only total row: visible only in print via CSS */}
                            <table style={{ width: '5%', borderCollapse: 'collapse', fontSize: 12 }}>
                                <tfoot>
                                    <tr className={classes.printOnly}>
                                        <td style={{ border: '1px solid #ccc', padding: 6 }} colSpan={3}><strong>Sum Total</strong></td>
                                        <td style={{ border: '1px solid #ccc', padding: 6, textAlign: 'right' }}><strong>{formatMoney(paymentInstructionTotal)}</strong></td>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>

                        <div className={classes.modalActions} style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, marginTop: 12 }}>
                            <button
                                type="button"
                                className={classes.greenBtn}
                                onClick={handleMakePayment}
                                disabled={makingPayment}
                                style={{ padding: '8px 14px' }}
                            >
                                {makingPayment ? 'Processing...' : 'Make Payment'}
                            </button>
                            <button
                                type="button"
                                className={classes.greenBtn}
                                onClick={() => window.print()}
                                style={{ padding: '8px 14px' }}
                            >
                                Print
                            </button>
                            <button
                                type="button"
                                className={classes.cancelBtn}
                                onClick={() => setShowPaymentInstructionModal(false)}
                                style={{ padding: '8px 14px', border: '1px solid #ccc', background: '#fff' }}
                            >
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            )}

            <div className={`${classes.noPrint}`}>
                <HeaderNav activePage={pageMap[location.pathname]} />
            </div>

            <div className={classes.Container}>
                {/* Action Buttons */}
                <div className={classes.actions}>
                    <button className={classes.btns} onClick={() => navigate("/transactions/receivables/sales")}>
                        New Sales Invoice
                    </button>
                    <button className={classes.btns} onClick={() => navigate("/inventory/purchaseOrder")}>
                        New Purchase Invoice
                    </button>
                    <button className={classes.btns} onClick={() => navigate("/customer-sales")}>
                        All Invoices
                    </button>
                    <button className={`${classes.btns} ${classes.greens}`} onClick={() => navigate("/settings/product-services")}>
                        Product & Services
                    </button>

                </div>
                <div className={classes.act}>
                    <div />


                    {/* <form className={classes.form}>
                            <div className={classes.group}>
                                <label>Month:</label>
                                <div className={classes.dropdownWrapper} >
                                    <input
                                        type="month"
                                        className={classes.statusDropdown}
                                        value={selectedMonth}
                                        onChange={(e) => setSelectedMonth(e.target.value)}
                                    />
                                </div>
                            </div>

                            <div className={classes.group1}>
                                <button
                                    className={classes.greenBtn}
                                    type="button"
                                    onClick={handleProcessClick}
                                >
                                    <BarChart2 size={16} style={{ marginRight: "6px" }} />
                                    Process
                                </button>
                            </div>
                        </form> */}
                    <div className={classes.iconbarr}>
                        <button
                            className={classes.btns}
                            style={{ background: "#16A34A", color: "#fff" }}
                            onClick={() => setShowModal(true)}
                        >
                            Compute Payroll
                        </button>
                    </div>
                </div>
                <div className={classes.matron}> <div>
                    <button className={classes.backButton}
                        onClick={() => navigate(-1)}> <ArrowLeft size={16} style={{ marginRight: '6px' }}
                        />
                    </button>
                </div>
                    <div>
                        <p className={classes.toplea}>Monthly Salary Computation</p>
                        <p className={classes.topl}>Computation as of {new Date().toLocaleDateString()}</p>
                    </div>
                </div>

                <form className={classes.form}>
                    <div className={classes.group}>
                        <label>Date:</label>
                        <div className={classes.dropdownWrapper} >
                            <input
                                type="month"
                                className={classes.statusDropdown}
                                value={selectedMonth}
                                onChange={(e) => setSelectedMonth(e.target.value)} // Only update state, no filtering yet
                            />
                        </div>
                    </div>

                    <div className={classes.group1}>
                        <button
                            className={classes.greenBtn}
                            type="button"
                            onClick={handlePreviewClick} // Fetch and display data only when "Preview" is clicked
                        >
                            <BarChart2 size={16} style={{ marginRight: "6px" }} />
                            Preview
                        </button>
                    </div>
                    <div className={classes.group1}>
                        <button
                            className={classes.greenBtn}
                            type="button"
                            onClick={handleOpenPaymentInstruction}
                            // Fetch and display data only when "Preview" is clicked
                        >
                            <BarChart2 size={16} style={{ marginRight: "6px" }} />
                            Generate Payment Instruction
                        </button>
                    </div>
                    <div className={classes.group1}>
                        <button
                            className={classes.greenBtn}
                            type="button"
                            // onClick={handlePreviewClick} 
                            // Fetch and display data only when "Preview" is clicked
                        >
                            <img src={makepayment}  size={10} style={{ marginRight: "6px", width: "15.99px" , height: "15.99px" }} />
                            Make Payment
                        </button>
                    </div>
                </form>
                {/* === Payments Table === */}
                <div className={classes.tableContainer}>
                    <table className={classes.table}>
                        <thead>
                            <tr className={classes.tableHeader}>
                                <th>S/N</th>
                                <th>Month</th>
                                <th>Employee ID</th>
                                <th style={{textAlign: 'left'}}>Name</th>
                                <th>Grade</th>
                                <th>Step</th>
                                <th>Basic Salary ({baseCurrencyCode || "NGN"})</th>
                                {allowanceHeaders.map(header => <th key={header}>{header} ({baseCurrencyCode || "NGN"})</th>)}
                                <th>Total Allowances ({baseCurrencyCode || "NGN"})</th>
                                {deductionHeaders.map(header => <th key={header}>{header} ({baseCurrencyCode || "NGN"})</th>)}
                                <th>Total Deductions ({baseCurrencyCode || "NGN"})</th>
                                <th>Net Pay ({baseCurrencyCode || "NGN"})</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {loading ? (
                                // ✅ Skeleton loader
                                Array.from({ length: 9 }).map((_, rowIndex) => (
                                    <tr key={rowIndex}>
                                        {[...Array(10)].map((_, colIndex) => (
                                            <td key={colIndex}>
                                                <div className={classes.skeletonBox}></div>
                                            </td>
                                        ))}
                                    </tr>
                                ))
                            ) : Array.isArray(salaryCompetitionData) && salaryCompetitionData.length > 0 ? (
                                salaryCompetitionData.map((item, index) => {
                                    const salaryStructure = item.salary_structure || {};
                                    const allowanceMap = {};
                                    salaryStructure.allowances?.forEach(a => {
                                        allowanceMap[a.type_name] = a.amount;
                                    });

                                    const deductionMap = {};
                                    salaryStructure.deductions?.forEach(d => {
                                        deductionMap[d.type_name] = d.amount;
                                    });
                                    // Place tax under deductions like other deduction headers
                                    if (salaryStructure.tax !== undefined && salaryStructure.tax !== null) {
                                        deductionMap["Tax"] = salaryStructure.tax;
                                    }

                                    return (
                                        <tr key={item.employee_id || index}>
                                            <td style={{ padding: '4px 6px', lineHeight: 1.1, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{index + 1}</td>
                                            <td style={{ padding: '4px 6px', lineHeight: 1.1, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} title={selectedMonth}>{selectedMonth}</td> {/* Use the selected month */}
                                            <td>
                                                <div style={ellipsisStyle} title={item.employee_id || "—"}>
                                                    {item.employee_id || "—"}
                                                </div>
                                            </td>
                                            <td>
                                                <div style={{ ...ellipsisStyle, textAlign: "left" }} title={item.name || "—"}>
                                                    {item.name || "—"}
                                                </div>
                                            </td>
                                            <td>
                                                <div style={ellipsisStyle} title={item.grade || "—"}>
                                                    {item.grade || "—"}
                                                </div>
                                            </td>
                                            <td>
                                                <div style={ellipsisStyle} title={item.step || "—"}>
                                                    {item.step || "—"}
                                                </div>
                                            </td>
                                            <td style={{ textAlign: "right" }}>
                                                <div style={{ ...ellipsisStyle, textAlign: "right", maxWidth: 140 }}>
                                                    {salaryStructure ? formatMoney(salaryStructure.basic_salary) : "—"}
                                                </div>
                                            </td>
                                            {allowanceHeaders.map(header => (
                                                <td key={header} style={{ textAlign: "right" }}>
                                                    {allowanceMap[header] ? formatMoney(allowanceMap[header]) : "—"}
                                                </td>
                                            ))}
                                            <td style={{ textAlign: "right" }}>
                                                <div style={{ ...ellipsisStyle, textAlign: "right", maxWidth: 140 }}>
                                                    {salaryStructure ? formatMoney(salaryStructure.total_allowances) : "—"}
                                                </div>
                                            </td>
                                            {deductionHeaders.map(header => (
                                                <td key={header} style={{ textAlign: "right" }}>
                                                    {deductionMap[header] ? formatMoney(deductionMap[header]) : "—"}
                                                </td>
                                            ))}
                                            <td style={{ textAlign: "right" }}>
                                                <div style={{ ...ellipsisStyle, textAlign: "right", maxWidth: 140 }}>
                                                    {salaryStructure ? formatMoney(salaryStructure.total_deductions) : "—"}
                                                </div>
                                            </td>
                                            <td style={{ textAlign: "right" }}>
                                                <div style={{ ...ellipsisStyle, textAlign: "right", maxWidth: 140 }}>
                                                    {salaryStructure ? formatMoney(salaryStructure.net_salary) : "—"}
                                                </div>
                                            </td>
                                            <td style={{ textAlign: "right", display: "flex", gap: "12px", padding: "10px", }}>

                                                <span
                                                    onClick={() => handleOpenReceipt(item)} // Pass the correct item object
                                                    role="button"
                                                    tabIndex={0}
                                                    onKeyDown={(e) => { if (e.key === 'Enter') handleOpenReceipt(item); }}
                                                    aria-label={`Open receipt ${item.employee_id || "N/A"}`} // Use a fallback value
                                                >
                                                    <Eye size={16} style={{ margin: "", color: "rgb(22,163,74)", cursor: "pointer" }} />
                                                </span>
                                                <Printer size={16} style={{ cursor: "pointer", color: "blue" }} title="Print Salary Voucher" onClick={() => swal("Info", `Print salary voucher for ${item.name || item.employee_id || "employee"}`, "info")} />
                                                <Trash size={16} style={{ cursor: "pointer", color: "red" }} title="Delete Salary Voucher" onClick={() => swal("Info", `Delete salary voucher for ${item.name || item.employee_id || "employee"}`, "info")} />
                                            </td>
                                        </tr>
                                    );
                                })
                            ) : (
                                <tr>
                                    <td colSpan={12 + allowanceHeaders.length + deductionHeaders.length} style={{ textAlign: "center" }}>
                                        No salary computation data found.
                                    </td>
                                </tr>
                            )}
                        </tbody>

                    </table>
                </div>

                {/* Edit modal (simple inline modal) */}

            </div>
            <Footer />
        </div>
    );
};

export default MonthlySalaryCompetition;
